// extracted by mini-css-extract-plugin
export default {"Wrapper":"Layout_Wrapper__B1sc1","main-content":"Layout_main-content__8GJCd","nav-hide":"Layout_nav-hide__Ywfml"};